import React, { createContext, useContext, useState } from "react";

type StatusOptions = {
  status: string;
  color?: string;
};

type FooterStatusContextType = {
  status: StatusOptions;
  setStatus: (options: StatusOptions) => void;
  clearStatus: () => void;
};

const FooterStatusContext = createContext<FooterStatusContextType | undefined>(
  undefined
);

export const useFooterStatus = () => {
  const ctx = useContext(FooterStatusContext);
  if (!ctx)
    throw new Error("useFooterStatus must be used within FooterStatusProvider");
  return ctx;
};

export const FooterStatusProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [status, setStatusInternal] = useState<StatusOptions>({ status: "" });

  const setStatus = (options: StatusOptions) => {
    setStatusInternal(options);
  };

  const clearStatus = () => setStatusInternal({ status: "" });

  return (
    <FooterStatusContext.Provider value={{ status, setStatus, clearStatus }}>
      {children}
    </FooterStatusContext.Provider>
  );
};
